import { render } from "./EditCARelatedPayments.vue?vue&type=template&id=f066cd9a"
import script from "./EditCARelatedPayments.vue?vue&type=script&lang=js"
export * from "./EditCARelatedPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__